export const API_BASE = 'https://entrima.org/wp-json/wp/v2';

export const DEFAULT_REQUEST_ARGS = {
    per_page: '100',
    acf_format: 'standard',
}